var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "supsis-archive-modal-fade" } }, [
    _c(
      "div",
      {
        staticClass: "supsis-archive-modal-overlay-v2xuniq",
        on: { click: _vm.handleOverlayClick },
      },
      [
        _c(
          "div",
          {
            staticClass: "supsis-archive-modal-container-v2xuniq",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "supsis-archive-modal-header-v2xuniq" }, [
              _c(
                "div",
                { staticClass: "supsis-archive-header-content-v2xuniq" },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "material-icons supsis-archive-header-icon-v2xuniq",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.activeTab === "archive" ? "archive" : "delete"
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h2",
                    { staticClass: "supsis-archive-header-title-v2xuniq" },
                    [_vm._v(_vm._s(_vm.$t("task.archiveAndTrash")))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "supsis-archive-close-btn-v2xuniq",
                  on: { click: _vm.handleClose },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("close"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "supsis-archive-modal-body-v2xuniq" },
              [
                _c(
                  "div",
                  { staticClass: "supsis-archive-control-bar-v2xuniq" },
                  [
                    _c(
                      "div",
                      { staticClass: "supsis-archive-tab-switcher-v2xuniq" },
                      [
                        _c(
                          "button",
                          {
                            class: [
                              "supsis-archive-tab-btn-v2xuniq",
                              { active: _vm.activeTab === "archive" },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.switchTab("archive")
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("inventory_2"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "supsis-archive-tab-text-v2xuniq",
                              },
                              [_vm._v(_vm._s(_vm.$t("message.archive")))]
                            ),
                            _vm._v(" "),
                            _vm.activeTab === "archive" && _vm.totalTasks
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "supsis-archive-count-badge-v2xuniq",
                                  },
                                  [_vm._v(_vm._s(_vm.totalTasks))]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            class: [
                              "supsis-archive-tab-btn-v2xuniq",
                              { active: _vm.activeTab === "trash" },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.switchTab("trash")
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("delete_outline"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "supsis-archive-tab-text-v2xuniq",
                              },
                              [_vm._v(_vm._s(_vm.$t("task.trash")))]
                            ),
                            _vm._v(" "),
                            _vm.activeTab === "trash" && _vm.totalTasks
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "supsis-archive-count-badge-v2xuniq",
                                  },
                                  [_vm._v(_vm._s(_vm.totalTasks))]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "supsis-archive-action-bar-v2xuniq" },
                      [
                        _c(
                          "div",
                          { staticClass: "supsis-archive-date-filter-v2xuniq" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "material-icons supsis-archive-filter-icon-v2xuniq",
                              },
                              [_vm._v("event")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "supsis-archive-filter-label-v2xuniq",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.activeTab === "archive"
                                      ? _vm.$t("auto.archiveDate")
                                      : _vm.$t("auto.deleteDate")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("a-range-picker", {
                              staticClass:
                                "supsis-archive-date-range-input-v2xuniq",
                              attrs: {
                                placeholder: [
                                  _vm.$t("auto.start"),
                                  _vm.$t("auto.end"),
                                ],
                                format: "DD/MM/YYYY",
                              },
                              on: { change: _vm.handleDateChangeDebounced },
                              model: {
                                value: _vm.dateRange,
                                callback: function ($$v) {
                                  _vm.dateRange = $$v
                                },
                                expression: "dateRange",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "transition",
                              { attrs: { name: "supsis-archive-fade-scale" } },
                              [
                                _vm.dateRange && _vm.dateRange.length
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "supsis-archive-filter-clear-v2xuniq",
                                        on: { click: _vm.clearDateFilter },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [_vm._v("close")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.activeTab === "archive"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "supsis-archive-trash-search-v2xuniq",
                              },
                              [
                                _c(
                                  "a-input",
                                  {
                                    staticClass:
                                      "supsis-archive-trash-search-input-v2xuniq",
                                    attrs: {
                                      allowClear: "",
                                      placeholder: _vm.$t(
                                        "task.filterBar.searchTasksPlaceholder"
                                      ),
                                    },
                                    on: {
                                      change: _vm.handleArchiveSearchDebounced,
                                    },
                                    model: {
                                      value: _vm.archiveSearch,
                                      callback: function ($$v) {
                                        _vm.archiveSearch = $$v
                                      },
                                      expression: "archiveSearch",
                                    },
                                  },
                                  [
                                    _c("a-icon", {
                                      attrs: { slot: "prefix", type: "search" },
                                      slot: "prefix",
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activeTab === "trash"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "supsis-archive-trash-search-v2xuniq",
                              },
                              [
                                _c(
                                  "a-input",
                                  {
                                    staticClass:
                                      "supsis-archive-trash-search-input-v2xuniq",
                                    attrs: {
                                      allowClear: "",
                                      placeholder: _vm.$t(
                                        "task.filterBar.searchTasksPlaceholder"
                                      ),
                                    },
                                    on: {
                                      change: _vm.handleTrashSearchDebounced,
                                    },
                                    model: {
                                      value: _vm.trashSearch,
                                      callback: function ($$v) {
                                        _vm.trashSearch = $$v
                                      },
                                      expression: "trashSearch",
                                    },
                                  },
                                  [
                                    _c("a-icon", {
                                      attrs: { slot: "prefix", type: "search" },
                                      slot: "prefix",
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "supsis-archive-view-switcher-v2xuniq",
                          },
                          [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: _vm.$t("task.gridViewTooltip"),
                                    },
                                    expression:
                                      "{ content: $t('task.gridViewTooltip') }",
                                  },
                                ],
                                class: [
                                  "supsis-archive-view-btn-v2xuniq",
                                  { active: _vm.viewMode === "grid" },
                                ],
                                on: {
                                  click: function ($event) {
                                    _vm.viewMode = "grid"
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("apps"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: _vm.$t("task.listViewTooltip"),
                                    },
                                    expression:
                                      "{ content: $t('task.listViewTooltip') }",
                                  },
                                ],
                                class: [
                                  "supsis-archive-view-btn-v2xuniq",
                                  { active: _vm.viewMode === "list" },
                                ],
                                on: {
                                  click: function ($event) {
                                    _vm.viewMode = "list"
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("view_agenda"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "supsis-archive-fade", mode: "out-in" } },
                  [
                    _vm.loading
                      ? _c(
                          "div",
                          {
                            key: "loading",
                            staticClass:
                              "supsis-archive-content-loader-v2xuniq",
                          },
                          [
                            _c("a-spin", { attrs: { size: "large" } }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "supsis-archive-loading-text-v2xuniq",
                              },
                              [_vm._v(_vm._s(_vm.$t("task.loading")))]
                            ),
                          ],
                          1
                        )
                      : _vm.tasks && _vm.tasks.length > 0
                      ? _c(
                          "div",
                          {
                            key: "content",
                            staticClass: "supsis-archive-content-area-v2xuniq",
                          },
                          [
                            _c(
                              "div",
                              {
                                class:
                                  _vm.viewMode === "grid"
                                    ? "supsis-archive-tasks-grid-v2xuniq"
                                    : "supsis-archive-tasks-list-v2xuniq",
                              },
                              _vm._l(_vm.tasks, function (task) {
                                return _c(
                                  "div",
                                  {
                                    key: task._id,
                                    class:
                                      _vm.viewMode === "grid"
                                        ? "supsis-archive-task-grid-card-v2xuniq"
                                        : "supsis-archive-task-list-card-v2xuniq",
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(task)
                                      },
                                    },
                                  },
                                  [
                                    _vm.viewMode === "grid"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "supsis-archive-grid-card-inner-v2xuniq",
                                          },
                                          [
                                            task.attachments &&
                                            task.attachments.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-archive-card-image-v2xuniq",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.getAttachmentUrl(
                                                          task.attachments[0]
                                                        ),
                                                        alt: task.title,
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-archive-card-image-v2xuniq supsis-archive-card-image-placeholder-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "material-icons supsis-archive-placeholder-icon-v2xuniq",
                                                      },
                                                      [_vm._v("task_alt")]
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "supsis-archive-card-body-v2xuniq",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-archive-card-header-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-card-title-v2xuniq",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(task.title)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "a-dropdown",
                                                          {
                                                            attrs: {
                                                              trigger: [
                                                                "click",
                                                              ],
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "overlay",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "a-menu",
                                                                        {
                                                                          staticClass:
                                                                            "supsis-archive-task-actions-menu-v2xuniq",
                                                                        },
                                                                        _vm._l(
                                                                          _vm.filteredActions,
                                                                          function (
                                                                            action
                                                                          ) {
                                                                            return _c(
                                                                              "a-menu-item",
                                                                              {
                                                                                key: action.action,
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.runAction(
                                                                                        action.action,
                                                                                        task
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "material-icons",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        action.icon
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  "\n                                                                " +
                                                                                    _vm._s(
                                                                                      action.text
                                                                                    ) +
                                                                                    "\n                                                            "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "supsis-archive-card-menu-btn-v2xuniq",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "more_vert"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                task.tags &&
                                                task.tags.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-card-tags-v2xuniq",
                                                      },
                                                      [
                                                        _vm._l(
                                                          task.tags.slice(0, 2),
                                                          function (tag) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key: tag._id,
                                                                staticClass:
                                                                  "supsis-archive-tag-chip-v2xuniq",
                                                                style:
                                                                  _vm.getTagStyle(
                                                                    tag.color
                                                                  ),
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      tag.name
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        task.tags.length > 2
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-archive-tag-more-v2xuniq",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      task.tags
                                                                        .length -
                                                                        2
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-archive-card-footer-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-card-priority-v2xuniq",
                                                      },
                                                      [
                                                        _c(
                                                          _vm.getPriorityIcon(
                                                            task.priority
                                                          ),
                                                          { tag: "component" }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-card-assignees-v2xuniq",
                                                      },
                                                      [
                                                        _vm._l(
                                                          _vm
                                                            .getAssigneesUserId(
                                                              task
                                                            )
                                                            .slice(0, 2),
                                                          function (userId) {
                                                            return _c(
                                                              "Avatar",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "tippy",
                                                                    rawName:
                                                                      "v-tippy",
                                                                    value: {
                                                                      content:
                                                                        _vm
                                                                          .users[
                                                                          userId
                                                                        ] &&
                                                                        _vm
                                                                          .users[
                                                                          userId
                                                                        ].email,
                                                                      placement:
                                                                        "top",
                                                                    },
                                                                    expression:
                                                                      "{\n                                                        content: users[userId] && users[userId].email,\n                                                        placement: 'top',\n                                                    }",
                                                                  },
                                                                ],
                                                                key: userId,
                                                                attrs: {
                                                                  size: 24,
                                                                  src:
                                                                    _vm.users[
                                                                      userId
                                                                    ] &&
                                                                    _vm.users[
                                                                      userId
                                                                    ].gravatar,
                                                                  username:
                                                                    _vm.users[
                                                                      userId
                                                                    ] &&
                                                                    _vm.users[
                                                                      userId
                                                                    ].name,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.getAssigneesUserId(
                                                          task
                                                        ).length > 2
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-archive-avatar-more-v2xuniq",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    +" +
                                                                    _vm._s(
                                                                      _vm.getAssigneesUserId(
                                                                        task
                                                                      ).length -
                                                                        2
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-card-stats-v2xuniq",
                                                      },
                                                      [
                                                        task.checklist &&
                                                        task.checklist.length >
                                                          0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-archive-stat-badge-v2xuniq",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "checklist"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.getCompletedChecklistCount(
                                                                        task
                                                                      )
                                                                    ) +
                                                                    "/" +
                                                                    _vm._s(
                                                                      task
                                                                        .checklist
                                                                        .length
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "supsis-archive-list-card-inner-v2xuniq",
                                          },
                                          [
                                            task.attachments &&
                                            task.attachments.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-archive-list-thumbnail-v2xuniq",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.getAttachmentUrl(
                                                          task.attachments[0]
                                                        ),
                                                        alt: task.title,
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "supsis-archive-list-content-v2xuniq",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-archive-list-header-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-list-title-v2xuniq",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(task.title)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      _vm.getPriorityIcon(
                                                        task.priority
                                                      ),
                                                      {
                                                        tag: "component",
                                                        staticClass:
                                                          "supsis-archive-priority-icon-v2xuniq",
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                task.description
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-list-description-v2xuniq",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              _vm.truncateText(
                                                                task.description,
                                                                100
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                task.tags &&
                                                task.tags.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-list-tags-v2xuniq",
                                                      },
                                                      [
                                                        _vm._l(
                                                          task.tags.slice(0, 3),
                                                          function (tag) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key: tag._id,
                                                                staticClass:
                                                                  "supsis-archive-list-tag-v2xuniq",
                                                                style:
                                                                  _vm.getTagStyle(
                                                                    tag.color
                                                                  ),
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      tag.name
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        task.tags.length > 3
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-archive-tag-more-v2xuniq",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      task.tags
                                                                        .length -
                                                                        3
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-archive-list-footer-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-list-assignees-v2xuniq",
                                                      },
                                                      [
                                                        _vm._l(
                                                          _vm
                                                            .getAssigneesUserId(
                                                              task
                                                            )
                                                            .slice(0, 3),
                                                          function (userId) {
                                                            return _c(
                                                              "Avatar",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "tippy",
                                                                    rawName:
                                                                      "v-tippy",
                                                                    value: {
                                                                      content:
                                                                        _vm
                                                                          .users[
                                                                          userId
                                                                        ] &&
                                                                        _vm
                                                                          .users[
                                                                          userId
                                                                        ].email,
                                                                      placement:
                                                                        "top",
                                                                    },
                                                                    expression:
                                                                      "{\n                                                        content: users[userId] && users[userId].email,\n                                                        placement: 'top',\n                                                    }",
                                                                  },
                                                                ],
                                                                key: userId,
                                                                attrs: {
                                                                  size: 24,
                                                                  src:
                                                                    _vm.users[
                                                                      userId
                                                                    ] &&
                                                                    _vm.users[
                                                                      userId
                                                                    ].gravatar,
                                                                  username:
                                                                    _vm.users[
                                                                      userId
                                                                    ] &&
                                                                    _vm.users[
                                                                      userId
                                                                    ].name,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.getAssigneesUserId(
                                                          task
                                                        ).length > 3
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-archive-avatar-more-v2xuniq",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    +" +
                                                                    _vm._s(
                                                                      _vm.getAssigneesUserId(
                                                                        task
                                                                      ).length -
                                                                        3
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-archive-list-meta-v2xuniq",
                                                      },
                                                      [
                                                        task.checklist &&
                                                        task.checklist.length >
                                                          0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-archive-meta-badge-v2xuniq",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "checklist"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.getCompletedChecklistCount(
                                                                        task
                                                                      )
                                                                    ) +
                                                                    "/" +
                                                                    _vm._s(
                                                                      task
                                                                        .checklist
                                                                        .length
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        (task.subTasks || [])
                                                          .length > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-archive-meta-badge-v2xuniq",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "account_tree"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.getCompletedParentTaskCount(
                                                                        task
                                                                      )
                                                                    ) +
                                                                    "/" +
                                                                    _vm._s(
                                                                      task
                                                                        .subTasks
                                                                        .length
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a-dropdown",
                                                      {
                                                        attrs: {
                                                          trigger: ["click"],
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                          },
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "overlay",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "a-menu",
                                                                    {
                                                                      staticClass:
                                                                        "supsis-archive-task-actions-menu-v2xuniq",
                                                                    },
                                                                    _vm._l(
                                                                      _vm.filteredActions,
                                                                      function (
                                                                        action
                                                                      ) {
                                                                        return _c(
                                                                          "a-menu-item",
                                                                          {
                                                                            key: action.action,
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.runAction(
                                                                                    action.action,
                                                                                    task
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "material-icons",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    action.icon
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              "\n                                                            " +
                                                                                _vm._s(
                                                                                  action.text
                                                                                ) +
                                                                                "\n                                                        "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "supsis-archive-list-menu-btn-v2xuniq",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "more_vert"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            key: "empty",
                            staticClass: "supsis-archive-empty-state-v2xuniq",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "supsis-archive-empty-illustration-v2xuniq",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "material-icons supsis-archive-empty-icon-v2xuniq",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.activeTab === "archive"
                                            ? "inventory_2"
                                            : "delete_outline"
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "supsis-archive-empty-title-v2xuniq",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.activeTab === "archive"
                                        ? _vm.$t("task.noArchivedTasks")
                                        : _vm.$t("task.noDeletedTasks")
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "supsis-archive-empty-description-v2xuniq",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.activeTab === "archive"
                                        ? "Arşivlenmiş görev bulunmamaktadır."
                                        : "Silinmiş görev bulunmamaktadır."
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "supsis-archive-slide-up" } }, [
              !_vm.loading && _vm.tasks && _vm.tasks.length > 0
                ? _c(
                    "div",
                    { staticClass: "supsis-archive-modal-footer-v2xuniq" },
                    [
                      _c(
                        "div",
                        { staticClass: "supsis-archive-footer-info-v2xuniq" },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("info"),
                          ]),
                          _vm._v("\n                        Toplam "),
                          _c("strong", [_vm._v(_vm._s(_vm.totalTasks))]),
                          _vm._v(" görev\n                    "),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-pagination", {
                        staticClass: "supsis-archive-custom-pagination-v2xuniq",
                        attrs: {
                          total: _vm.totalTasks,
                          pageSize: _vm.perPage,
                          showTotal: function (total, range) {
                            return range[0] + "-" + range[1]
                          },
                          showSizeChanger: false,
                        },
                        on: { change: _vm.handlePageChange },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }